module.exports = __webpack_public_path__ + "static/media/inclusion_maternity.05d48a3f.svg";